import React, { useEffect, useState } from 'react';

import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Fragment } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import SweetAlert from 'react-bootstrap-sweetalert';

import { useParams } from 'react-router-dom';

import BaseRulesDetail from 'components/Tvendo/Sale/QuotaBPartner/Rules/BaseRulesDetail/List.js';
import BaseRulesCanal from 'components/Tvendo/Sale/QuotaBPartner/Rules/BaseRulesCanal/List.js';
import { Toasty, useToasty } from 'hooks/Toasty';
import { wsRemove } from 'services/WService';

//Tabs
import { TabPanel, indexTab, useStyleTabs } from 'hooks/TabPanel';
import { wsGet } from 'services/WService';
import { wsFindBy } from 'services/WService';

const useStyles = makeStyles(styles);

export default function () {
  const claseStyleTab = useStyleTabs();
  const classes = useStyles();

  const { id } = useParams();
  const [value, setValue] = useState(0);
  const [notify, showNotify] = useToasty();

  const themeTab = useTheme();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const [alert, setAlert] = useState(null);
  const hideAlert = () => {
    setAlert(null);
  };
  function confirm(entity, id, reload) {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="Esta seguro de eliminar!"
        onConfirm={() => {
          remove(entity, id, reload);
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      />
    );
  }

  async function remove(entity, id, reload) {
    let response = await wsRemove(entity, id);
    if (response.success) {
      showNotify(response.message);
      reload();
    } else {
      showNotify(response.message, 'error');
    }
  }

  //#region Listados de api
  const [reglas, setReglas] = useState({});
  const [rDetails, setRDetails] = useState([]);
  const [rCanals, setRCanals] = useState([]);

  async function getReglas() {
    let response = await wsGet('sale/reglas-cobertura', id);
    if (response.success) {
      setReglas(response.data);
      // setGIDetails(response.data.details);
      // setGICanals(response.data.canals);
    }
  }
  async function getReglasDetail() {
    let response = await wsFindBy('sale/reglas-cobertura-detalle', { base_rule_id: reglas.id });
    if (response.success) setRDetails(response.data);
  }
  async function getReglasCanal() {
    let response = await wsFindBy('sale/reglas-cobertura-canal', { rule_id: reglas.id });
    if (response.success) setRCanals(response.data);
  }

  useEffect(() => {
    getReglas();
  }, []);

  useEffect(()=> {
    if(reglas.id){
      getReglasDetail();
      getReglasCanal();
    }
  },[reglas.id]);

  return (
    <Fragment>
      <Toasty action={notify} />
      {alert}
      {id != 0 ? (
        <Fragment>
          <h4 style={{ fontWeight: 'bold' }}>Regla: {reglas.cobertura}</h4>
          <div className={claseStyleTab.root}>
            <AppBar position="static" color="default">
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                textColor="secondary"
                aria-label="Tabs"
                indicatorColor="secondary"
              >
                <Tab label="Detalle" {...indexTab(0)} />
                <Tab label="Distribución" {...indexTab(1)} />
              </Tabs>
            </AppBar>
            <SwipeableViews
              axis={themeTab.direction === 'rtl' ? 'x-reverse' : 'x'}
              index={value}
              onChangeIndex={handleChangeIndex}
            >
              <TabPanel value={value} index={0} dir={themeTab.direction}>
                <BaseRulesDetail
                  id={id}
                  showNotify={showNotify}
                  confirm={confirm}
                  rDetails={rDetails}
                  setRDetails={setRDetails}
                  reglas={reglas}
                  reload={getReglasDetail}
                />
              </TabPanel>
              <TabPanel value={value} index={1} dir={themeTab.direction}>
                <BaseRulesCanal
                  id={id}
                  showNotify={showNotify}
                  confirm={confirm}
                  rCanals={rCanals}
                  setRCanals={setRCanals}
                  reglas={reglas}
                  reload={getReglasCanal}
                />
              </TabPanel>
            </SwipeableViews>
          </div>
        </Fragment>
      ) : undefined}
    </Fragment>
  );
}
